import React from 'react';
import { Box } from '@mui/material';
import { VersionBadge } from '../components/version-badge';

interface AppLayoutProps {
  header: React.ReactNode;
  children: React.ReactNode;
  bottomBar?: React.ReactNode;
}

/**
 * AppLayout — Flutter Scaffold equivalent.
 * Header: fixed 56px (kToolbarHeight).
 * Content: scrollable area with #F5F5F5 background.
 * BottomBar: auto-height, anchored to bottom.
 */
export const AppLayout: React.FC<AppLayoutProps> = ({ header, children, bottomBar }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'background.default',
      }}
    >
      {/* AppBar region — fixed height */}
      <Box sx={{ flexShrink: 0 }}>
        {header}
      </Box>

      {/* Content region — scrollable */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {children}
      </Box>

      {/* BottomBar region — auto height, anchored */}
      {bottomBar && (
        <Box sx={{ flexShrink: 0 }}>
          {bottomBar}
        </Box>
      )}

      {/* Version — very bottom, below everything */}
      <VersionBadge />
    </Box>
  );
};
